import React from "react";
import {useTranslation} from "react-i18next";
import {CityFilterPropTypes} from "./FilterComponentPropTypes";
import {SelectField} from "./FilterComponentStyles";
import {cities} from "../../../constants/constants";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {useStore} from "../../../hooks/useStore";

const CityFilter = ({
    value,
    onChange,
    showLabel = true,
    restrictedCities = [],
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    ignoreCompanyCheck = false
}: CityFilterPropTypes) => {
    const {t} = useTranslation();
    const stores = useStore();
    if (stores.meStore.auth.cities?.length == 1) {
        showAllOption = false;
        value = stores.meStore.auth.cities[0];
    }
    return (
        <React.Fragment>
            {showLabel && <h5>{t("fields.city", {ns: "common"})}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="city"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {arrayAlphabeticalSort([...cities])
                    .filter(c => (!showAllOption ? c.value.toLowerCase() !== "all" : true))
                    .filter(c =>
                        showAllOption && c?.value?.toLowerCase() === "all"
                            ? true
                            : !restrictedCities
                                  .map(rC => rC.toLocaleLowerCase("tr-TR"))
                                  .includes(c?.name?.toLocaleLowerCase("tr-TR"))
                    )

                    .filter(c =>
                        !stores.meStore.checkRole("isCompanyUser") || ignoreCompanyCheck
                            ? stores.meStore.auth.cities?.length > 0
                                ? stores.meStore.auth.cities.includes(c.value) || c.value == "all"
                                : true
                            : c.value.toLowerCase() === "all" ||
                              stores.meStore.subcompanies
                                  .map(subcompany => subcompany.city)
                                  .includes(c.value)
                    )
                    .map((city, i) => (
                        <SelectField.Option
                            data-testid="city_option"
                            key={i}
                            data-center={city.center}
                            value={city.value}
                        >
                            {city.value.toLowerCase() === "all"
                                ? t("filters.all", {ns: "common"})
                                : city.name}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    );
};

export default CityFilter;
